<template>
  <div>
    <RevInputNumber
      id="telco_monthly_cost"
      v-model="monthlyCost"
      class="mt-16"
      :label="i18n(translations.monthlyCost)"
      :min="0"
      :precision="2"
      :step="5"
      @update:model-value="handleInputChange('telco_monthly_cost')"
    />
    <div class="mt-16 flex justify-between">
      <div class="body-1">{{ i18n(translations.contractLength) }}</div>
      <div class="body-1-bold">
        {{
          i18n(translations.contractDurationByMonth, {
            duration: i18n(translations.contractDuration),
          })
        }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import type { Price } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevInputNumber } from '@ds/components/InputNumber'

import translations from './USTelcoCalculatorModalCalculator.translations'

const props = defineProps<{
  price: Price
}>()

const emit = defineEmits<{
  (
    e: 'price-changed',
    payload: {
      priceTelco: number
      priceBM: number
      savings: number
    },
  ): void
}>()

const monthlyCost = ref<number>(75)

const i18n = useI18n()
const { trackClick } = useTracking()

function handleInputChange(name?: string) {
  const devicePrice = parseFloat(props.price.amount)
  const contractDuration = parseFloat(i18n(translations.contractDuration))
  const monthlyCostBM = parseFloat(i18n(translations.contractBMMonthlyCost))

  const priceTelco = monthlyCost.value * contractDuration
  const priceBM = devicePrice + monthlyCostBM * contractDuration
  const savings = priceTelco - priceBM

  emit('price-changed', { priceTelco, priceBM, savings })

  if (name) {
    trackClick({
      zone: 'telco_calculator',
      name,
      value: { monthlyCost: monthlyCost.value },
    })
  }
}

onMounted(() => {
  handleInputChange()
})
</script>
